var _path, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowPrev(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5784 18.6357C11.8342 18.6357 12.0904 18.5363 12.2854 18.3408L12.3713 18.2549C12.7623 17.8639 12.7623 17.2308 12.3713 16.8408L8.50806 12.9775L21.5784 12.9775C22.1304 12.9775 22.5784 12.5295 22.5784 11.9775C22.5784 11.4255 22.1304 10.9775 21.5784 10.9775L8.50806 10.9775L12.3713 7.11426C12.7623 6.72326 12.7623 6.0902 12.3713 5.7002L12.2854 5.61426C11.8944 5.22326 11.2613 5.22326 10.8713 5.61426L5.21509 11.2705C4.82409 11.6615 4.82409 12.2946 5.21509 12.6846L10.8713 18.3408C11.0668 18.5363 11.3225 18.6357 11.5784 18.6357Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.42188,
    y: 19.5,
    width: 2,
    height: 15,
    rx: 1,
    transform: "rotate(180 3.42188 19.5)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowPrev);
export default __webpack_public_path__ + "static/media/ArrowPrev.f15b1d1eb4561cd3091b8321274646e6.svg";
export { ForwardRef as ReactComponent };